module.exports = __webpack_public_path__ + "static/media/McKinseySans-Medium.5a0a82ea.woff";